import { render, staticRenderFns } from "./ExtendedProfile.vue?vue&type=template&id=38bd6251&"
import script from "./ExtendedProfile.vue?vue&type=script&lang=js&"
export * from "./ExtendedProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports